module.exports = __webpack_public_path__ + "static/media/shape_G.b21e7882.glb";